export default __webpack_public_path__ + "static/media/chart-icon.f3c9e374.svg";